// extracted by css-extract-rspack-plugin
var _1 = "Bu91OcmhfAM5iMpu";
var _2 = "unX4lE5McscqYwFS";
var _3 = "r4yMzEVd4XwEC8gO";
var _4 = "c0aH59PNc9MefHqd";
var _5 = "ofy4s_ZNB0I0Emw6";
export { _1 as "imageColumn", _2 as "infoColumn", _3 as "infoContent", _4 as "priceRow", _5 as "section" }
// extracted by css-extract-rspack-plugin
var _1 = "Bu91OcmhfAM5iMpu";
var _2 = "unX4lE5McscqYwFS";
var _3 = "r4yMzEVd4XwEC8gO";
var _4 = "c0aH59PNc9MefHqd";
var _5 = "ofy4s_ZNB0I0Emw6";
export { _1 as "imageColumn", _2 as "infoColumn", _3 as "infoContent", _4 as "priceRow", _5 as "section" }
